enum TypeBudget {
	BUDGET_PRIMITIF = 'BP',
	BUDGET_SUPPLEMENTAIRE = 'BS',
	COMPTE_ADMINISTRATIF = 'CA',
	DECISION_MODIFICATIVE = 'DM',
	VIREMENT_INTERNE = 'VI',
}

export default TypeBudget;
